import { BroadcastAudienceType } from 'types'

interface BroadcastAudienceOption {
	label: string
	value: BroadcastAudienceType
}

const broadcastAudienceOptions: BroadcastAudienceOption[] = [
	{
		label: 'All Opted In',
		value: 'ALL_OPTED_IN',
	},
	{
		label: 'Contact List',
		value: 'VIEW_SELECTED',
	},
	{
		label: 'Tag Selected',
		value: 'TAG_SELECTED',
	},
	{
		label: 'Upload Contacts',
		value: 'UPLOAD',
	},
	{
		label: 'Imported File',
		value: 'IMPORTED_FILE',
	},
	{
		label: 'Intelligent Audience',
		value: 'INTELLIGENT_AUDIENCE',
	},
]

export default broadcastAudienceOptions
